import { headers} from "../../common/credentials";

export const port = "2200";
const baseUrl = "http://172.16.40.14:";

export const getFileUploadListFromServer = () => {
    let url = baseUrl + port + "/api/v2/user_modules/medical_insurance/file_uploads/";
    return ([headers, url]);
}